import { ExclamationCircleIcon } from '@shared/assets/icons';
import type { MessagesStats } from '@pages/event/api/useFetchMessagesStats';
import { SendContentType } from '@pages/event/api/useSendMessages';
import clsx from 'clsx';
import { FC, useMemo } from 'react';
import { buildStatisticsMetrics } from '../../lib/channel-metrics';
import type { UnsentErrorChannel } from '../../lib/types';
import { MetricCard } from '../metric-card';
import styles from './statistics-content.module.scss';

interface StatisticsContentProps {
  messagesStats: MessagesStats;
  contentType: SendContentType;
  onViewUnsent: (channel: UnsentErrorChannel) => void;
}

export const StatisticsContent: FC<StatisticsContentProps> = ({ messagesStats, contentType, onViewUnsent }) => {
  const { total, vkTeams, email, sms, hasUnsentTickets } = useMemo(
    () => buildStatisticsMetrics(messagesStats),
    [messagesStats]
  );

  const isTicket = contentType === SendContentType.Ticket;
  const summaryText = isTicket ? 'Билеты сформированы и отправлены' : 'Приглашения сформированы и отправлены';
  const unsentAlertText = isTicket ? 'Есть неотправленные билеты' : 'Есть неотправленные приглашения';

  return (
    <div className={clsx(styles.content, hasUnsentTickets && styles.contentWithAlert)}>
      <div className={styles.section}>
        <p className={styles.summary}>{summaryText}</p>

        <div className={styles.metrics}>
          <MetricCard metric={total} />
          {vkTeams.isVisible && <MetricCard metric={vkTeams} onViewUnsent={() => onViewUnsent('vkTeams')} />}
          {email.isVisible && <MetricCard metric={email} onViewUnsent={() => onViewUnsent('email')} />}
          {sms.isVisible && <MetricCard metric={sms} onViewUnsent={() => onViewUnsent('sms')} />}
        </div>
      </div>

      {hasUnsentTickets && (
        <div className={styles.errorAlert}>
          <ExclamationCircleIcon />
          <p className={styles.errorAlertText}>{unsentAlertText}</p>
        </div>
      )}
    </div>
  );
};
